import React, { useEffect, useContext } from "react"
import { GlobalContext } from "@Context/context/GlobalState"
import PublishIcon from "@material-ui/icons/Publish"
import { TableMassiveLoads } from "@Components/TableMassiveLoads"
import { useTranslation } from "react-i18next"
import rsc from "@Config/resources"
import { useHistory } from "react-router"
import { useEnv } from "@Hooks"

const ListMassiveLoadsScreen = () => {
  const { handleRoutingBreadcrumbs } = useContext(GlobalContext)
  const { t } = useTranslation("global")
  const history = useHistory()

  const { multiclient } = useEnv()

  useEffect(() => {
    if (
      !multiclient.permissions_v3_on(
        [rsc.MASSIVE_LOAD, rsc.MASSIVE_LOAD_LIST_MASSIVE_LOAD_LIST],
        [rsc.CmListLoadRouteCoverage, rsc.MASSIVE_LOAD_LIST_MASSIVE_LOAD_LIST],
      )
    ) {
      return history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleRoutingBreadcrumbs({
      titleHeader: t("massive-loads"),
      routes: [{ name: t("massive-loads"), route: "/massive_loads" }],
      icon: <PublishIcon style={{ marginRight: 5, opacity: 0.5 }} />,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <TableMassiveLoads />
}

export default ListMassiveLoadsScreen
